<template>
	<div id="tile-grid">
		<div class="tile is-ancestor is-mobile mx-2" style="flex-wrap: wrap;">
			<div
				v-for="(item, i) in items"
				:key="'item' + i"
				class="tile is-parent is-vertical is-mobile is-3"
			>
				<a :href="item.link" target="_blank" class="tile is-child notification is-bg-accent">
					<article >
						<figure class="image" v-if="item.image">
							<img :src="item.image" />
						</figure>
						<p class="title is-5 has-text-left"><span><i class="fa fa-info-circle"></i></span> {{ item.title }}</p>
						<p v-if="item.message">{{ item.message }}</p>
					</article>
				</a>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import { QuoteItem } from "@/domain/entities/Misc";

	export default defineComponent({
		props: {
			items: {
				type: Array,
				default: () => [] as QuoteItem[],
			},
		},
	});
</script>